'use client';

import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import PartnershipTiers from './PartnershipTiers';
import APIExplorer from './APIExplorer';
import AirlinePartners from './AirlinePartners';
import RevenueCalculator from './RevenueCalculator';
import IntegrationTimeline from './IntegrationTimeline';
import WhiteLabelShowcase from './WhiteLabelShowcase';
import DeveloperCommunity from './DeveloperCommunity';
import CTASection from './CTASection';

export default function PartnerIntegrationInteractive() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleGetStarted = () => {
    if (isHydrated) {
      alert('Redirecting to integration signup...');
    }
  };

  const handleViewDocs = () => {
    if (isHydrated) {
      alert('Opening API documentation...');
    }
  };

  const handleSelectTier = (tierName: string) => {
    if (isHydrated) {
      alert(`Selected ${tierName} tier. Redirecting to signup...`);
    }
  };

  const handleScheduleDemo = () => {
    if (isHydrated) {
      alert('Opening demo scheduling calendar...');
    }
  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="animate-pulse space-y-8 py-16">
          <div className="h-96 bg-muted rounded-lg mx-4" />
          <div className="h-64 bg-muted rounded-lg mx-4" />
          <div className="h-64 bg-muted rounded-lg mx-4" />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <HeroSection 
        onGetStarted={handleGetStarted}
        onViewDocs={handleViewDocs}
      />
      <AirlinePartners />
      <PartnershipTiers onSelectTier={handleSelectTier} />
      <APIExplorer />
      <RevenueCalculator />
      <IntegrationTimeline />
      <WhiteLabelShowcase />
      <DeveloperCommunity />
      <CTASection 
        onGetStarted={handleGetStarted}
        onScheduleDemo={handleScheduleDemo}
      />
    </div>
  );
}